<template>
    <div class="wrap-history">
        <div class="title-page">History Withdraw</div>

        <div class="filter">
            <div class="text-right">
                <button type="button" class="btn btn-primary" @click="isShowfilter = !isShowfilter">Filter</button>
            </div>
            <div class="wrap-conten-filter" v-if="isShowfilter">
                <div class="filter-by-date">
                    <div class="form-group">
                        <label for="">Start Date</label>
                        <input type="date" id="start-date" :max="today" class="form-input" v-model="startDate" />
                    </div>
                    <div class="form-group">
                        <label for="">End Date</label>
                        <input
                            placeholder="Pilih tanggal akhir"
                            type="date"
                            id="start-date"
                            class="form-input"
                            v-model="endDate"
                            :min="startDate"
                            :disabled="startDate == ''"
                        />
                    </div>
                </div>
                <div class="filter-by-owner">
                    <div class="form-group">
                        <label for="">Owner</label>
                        <select name="" id="" v-model="owner" v-if="type == 'offexchange'">
                            <option value="" selected disabled>Choose Owner</option>
                            <option v-for="client in datalistClient" :key="client" :value="client">{{ client }}</option>
                        </select>
                        <select class="form-input" v-model="owner" v-else>
                            <option value="ALL">ALL</option>
                            <option value="LP000009">LP000009</option>
                            <option value="CP000002">CP000002</option>
                        </select>
                    </div>
                </div>
                <div class="wrap-button">
                    <button type="button" class="btn" @click="isShowfilter = false">Cancel</button>
                    <button type="button" class="btn btn-success" @click="filterTabel">Apply</button>
                </div>
            </div>
        </div>

        <div>
            <table>
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Deposit Date</th>
                        <th>Owner</th>
                        <th>Metal</th>
                        <th>Fineness</th>
                        <th>Hallmark</th>
                        <th>Weight (gr)</th>
                        <th>Status</th>
                        <!-- <th>Action</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(history, i) in dataDeposit" :key="i">
                        <td>{{ i + 1 }}</td>
                        <td>{{ history.metal_date | formatDate }}</td>
                        <td>{{ history.owner }}</td>
                        <td v-if="history.metal">{{ history.metal.type + " " + history.metal.form }}</td>
                        <td>{{ history.fineness }}</td>
                        <td>{{ history.hallmark }}</td>
                        <td>{{ history.weight }}</td>
                        <td>
                            <div v-if="type == 'onexchange'">
                                <span v-show="history.status == '001'" class="status-withdrawal request">Processing</span>
                                <span v-show="history.status == '002'" class="status-withdrawal kbi">Clearing Agreement</span>
                                <span v-show="history.status == '003'" class="status-withdrawal abx">KMI Confirmation</span>
                                <span v-show="history.status == '004'" class="status-withdrawal operator">Operator Confirmed</span>
                                <span v-show="history.status == '005'" class="status-withdrawal kbi">Clearing Confirmation</span>
                                <span v-show="history.status == '006'" class="status-withdrawal shipping">Shipping Confirmation</span>
                                <span v-show="history.status == '007'" class="status-withdrawal handover">Handover Confirmation</span>
                                <span v-show="history.status == '008'" class="status-withdrawal kprk">KPRK Recieved</span>
                                <span v-show="history.status == '009'" class="status-withdrawal nasabah">Delivered</span>
                                <span v-show="history.status == '010'" class="status-withdrawal decline">Declined By Vault Admin</span>
                            </div>
                            <div v-else>
                                <span v-show="history.status == '001'" class="status-withdrawal request">Processing</span>
                                <span v-show="history.status == '002'" class="status-withdrawal kbi">Clearing Approve</span>
                                <span v-show="history.status == '003'" class="status-withdrawal abx">KMI Approve</span>
                                <span v-show="history.status == '004'" class="status-withdrawal handover">Client add detail withdrawal</span>
                                <span v-show="history.status == '005'" class="status-withdrawal operator">Operator Confirmation</span>
                                <span v-show="history.status == '006'" class="status-withdrawal kbi">Clearing Confirmation</span>
                                <span v-show="history.status == '007'" class="status-withdrawal abx">KMI Confirmation</span>
                                <span v-show="history.status == '008'" class="status-withdrawal handover">Client Withdrawal</span>
                            </div>
                        </td>
                        <!-- <td></td> -->
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end mt-3">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalData"
                :per-page="perPage"
                @change="handlePageChange"
                aria-controls="new-table"
                first-number
                last-number
                v-show="totalData > 10"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
// import DepositOffexchangeTemp from "../../deposit/DepositOffexchangeTemp.vue";
export default {
    // components: { DepositOffexchangeTemp },
    data() {
        return {
            activity: "withdrawal",
            startDate: "",
            endDate: "",
            perPage: 10,
            currentPage: 1,
            type: "offexchange",
            owner: "",
            isShowfilter: false,
            today: "",
            filterData: {},
        };
    },
    computed: {
        dataDeposit() {
            return this.$store.state.bappebtiModule.dataHistories;
        },
        datalistClient() {
            return this.$store.state.bappebtiModule.dataListClient;
        },
        totalData() {
            return this.$store.state.bappebtiModule.totalDataHistories;
        },
    },
    mounted() {
        // const role = sessionStorage.getItem("role");
        // if (role == 8) {
        //     this.type = "onexchange";
        // } else {
        //     this.type = "offexchange";
        // }
        this.$store.dispatch("getListClient");
        this.today = new Date().toISOString().split("T")[0];
        this.$store.dispatch("getHistoryData", {
            activity: this.activity,
            startDate: this.startDate,
            endDate: this.endDate,
            perPage: this.perPage,
            currentPage: this.currentPage,
            type: this.type,
            owner: this.owner,
        });
    },
    methods: {
        filterTypeDeposit(value) {
            this.type = value;
            this.$store.dispatch("getHistoryData", {
                activity: this.activity,
                startDate: this.startDate,
                endDate: this.endDate,
                perPage: this.perPage,
                currentPage: this.currentPage,
                type: value,
                owner: this.owner,
            });
        },
        handlePageChange(value) {
            this.$store.dispatch("getHistoryData", {
                activity: this.activity,
                startDate: this.startDate,
                endDate: this.endDate,
                perPage: this.perPage,
                currentPage: value,
                type: this.type,
                owner: this.owner,
            });
        },
        filterTabel() {
            this.$store.dispatch("getHistoryData", {
                activity: this.activity,
                startDate: this.startDate,
                endDate: this.endDate,
                perPage: this.perPage,
                currentPage: this.currentPage,
                type: this.type,
                owner: this.owner,
            });
            this.isShowfilter = false;
        },
    },
};
</script>

<style scoped>
.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.nav-tab {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #636366;
    padding: 0.8rem 0;
}

.tab {
    padding: 0.8rem 1rem;
    cursor: pointer;
}

.tab:hover,
.activeTab {
    color: var(--clr-scondary);
    border-bottom: 2px solid var(--clr-scondary);
}

.filter {
    margin-bottom: 1rem;
}

.form-group label {
    display: block;
}

.form-group input,
select {
    width: 100%;
    margin-bottom: 0.75rem;
    border: 1px solid #ddd;
    padding: 0.2rem 0.5rem;
    border-radius: 5px;
}

.form-group button {
    width: 100%;
    font-size: 13px !important;
}

.wrap-button {
    display: flex;
    justify-content: end;
    gap: 1rem;
}
</style>
